<div [@slideInTop] class="navb"><app-navigation-bar></app-navigation-bar></div>

<section class="container-md px-0">
  <main>
    <section id="hero" appInView (inView)="fadeIn($event)">
      <h1>Управлявайте парите си с лекота</h1>
      <p>MYLEV улеснява създаването и спазването на бюджет.</p>
    </section>
    <section id="features">
      <div class="feature" appInView (inView)="slideFromLeft($event)">
        <img src="https://cdn-icons-png.flaticon.com/512/781/781831.png" alt="Budget">
        <h3>Създайте бюджет</h3>
        <p>Създайте месечен бюджет, спрямо вашите анализи, който ще работи за вас.</p>
      </div>
      <div class="feature" appInView (inView)="slideFromTop($event)">
        <img src="https://cdn-icons-png.flaticon.com/512/7185/7185530.png" alt="Goals">
        <h3>Поставяне на цели</h3>
        <p>Поставете си финансови цели и следете напредъка си.</p>
      </div>
      <div class="feature" appInView (inView)="slideFromRight($event)">
        <img src="https://cdn-icons-png.flaticon.com/512/2311/2311838.png" alt="Transactions">
        <h3>Проследяване на трансакции</h3>
        <p>Проследявайте трансакциите си и знайте точно къде отиват парите Ви.</p>
      </div>
      <div class="feature" appInView (inView)="onInView($event)">
        <img src="https://cdn-icons-png.flaticon.com/512/3534/3534063.png" alt="Reports">
        <h3>Преглед на отчети</h3>
        <p>Прегледайте отчетите си за определен месец, за да видите как се справяте с бюджета си.</p>
      </div>
    </section>
  </main>
</section>

<footer appInView (inView)="onInView($event)">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h3>За нас</h3>
        <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да има
          контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да получите подробна
          информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
      </div>
      <div class="col-md-3">
        <h3>За връзка</h3>
        <ul>
          <li>Димитър Найденов 100</li>
          <li>Велико Търново, България</li>
          <li>Email: info@mylev.com</li>
        </ul>
      </div>
      <div class="col-md-3">
        <h3>Последвайте ни в</h3>
        <ul>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Instagram</a></li>
          <li><a href="#">LinkedIn</a></li>
        </ul>
      </div>
    </div>
    <hr>
    <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
  </div>
</footer>